import {ResponseData} from '@dvrd/fetch';
import {useEffect, useState} from 'react';
import Document from '../../models/documentModel';
import {DocumentType} from '../../util/enums';

export default function useDocuments(documentType: DocumentType): [Array<Document>, boolean] {
    const [documents, setDocuments] = useState<Array<Document>>([]);
    const [loading, setLoading] = useState(true);

    function loadDocuments() {
        Document.getAll({active: true, document_type: documentType},
            (documents: Array<Document>, success: boolean, _: ResponseData) => {
                setLoading(false);
                if (success) setDocuments(documents);
                // TODO Report else
            });
    }

    useEffect(() => {
        loadDocuments();
    }, [documentType]);

    return [documents, loading];
}